import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { AuthActions, useAuth } from '../../state/AuthSlice';
import { useSetLogoutHistoryState } from './useSetLogoutHistoryState';

interface UseLogoutOptions {
  onLogout?: () => void;
}

export function useLogout(options?: UseLogoutOptions) {
  const { onLogout } = options ?? {};

  const auth = useAuth();
  const dispatch = useDispatch();
  const setLogoutHistoryState = useSetLogoutHistoryState();
  const [isLoading, setIsLoading] = useState(false);

  if (!auth.isLogged && !auth.isPrelogged) return {};

  return {
    isLoading,
    logout: () => {
      setIsLoading(true);
      dispatch(AuthActions.logout());
      onLogout?.();
      setIsLoading(false);
      setLogoutHistoryState();
      if (auth.logoutUrls && auth.logoutUrls.length > 0) {
        window.location.href = auth.logoutUrls[0];
      }
    },
  };
}
